interface Props {
  markers: {
    lat: number;
    lng: number;
  }[];
  center?: {
    lat: number;
    lng: number;
  };
  containerStyle: {
    width: string;
    height: string;
  };
  gbpLink?: string | null;
  className?: string;
  linkClassName?: string;
  title?: string;
  iframeTabIndex?: number;
}

export default function GoogleMaps({
  containerStyle,
  markers,
  center,
  gbpLink,
  className,
  linkClassName,
  title = "Google map",
  iframeTabIndex,
}: Props) {
  const mapCenter = center ?? markers[0];
  const src = `https://www.google.com/maps?q=${mapCenter.lat},${mapCenter.lng}&z=15&output=embed`;

  return (
    <div className={`w-full overflow-hidden ${className ?? ""}`}>
      <iframe
        title={title}
        src={src}
        style={containerStyle}
        className="block w-full border-0"
        tabIndex={iframeTabIndex}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
      />
      {gbpLink ? (
        <a
          href={gbpLink}
          target="_blank"
          rel="nofollow noopener"
          className={
            linkClassName ??
            "mt-4 block text-center font-semibold text-primary-blue underline hover:text-primary-blue/80"
          }
        >
          Open in Google Maps
        </a>
      ) : null}
    </div>
  );
}
